// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-bundle-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
  max-width: 500px;
  min-height: 200px;
  background: #ffffff !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden !important;
  position: relative;
  z-index: 1;
  margin: 0 !important;
  padding: 0 !important;
}
:host-context(body.theme-dark) .delete-bundle-dialog {
  background: #1e1e2e !important;
  color: #e2e8f0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-header {
  background: #1e1e2e !important;
  color: #e2e8f0;
  border-bottom-color: #2d2d3f;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-header h2 {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-header .close-button {
  color: #94a3b8;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-header .close-button:hover {
  background: #2d2d3f;
  color: #cbd5e1;
  border-color: #3d3d52;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-header .close-button:active {
  background: #3d3d52;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-content .warning-content h3 {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-content .warning-content p {
  color: #94a3b8;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-content .warning-content .info-box {
  background: #2d2d3f;
  border-color: #3d3d52;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
  color: #64748b;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-content .warning-content .info-box span {
  color: #94a3b8;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-actions {
  background: #181825 !important;
  border-top-color: #2d2d3f;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-actions .cancel-btn {
  background: #2d2d3f;
  color: #94a3b8;
  border-color: #3d3d52;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-actions .cancel-btn:hover {
  background: #3d3d52;
  border-color: #4d4d62;
  color: #cbd5e1;
}
:host-context(body.theme-dark) .delete-bundle-dialog .dialog-actions .delete-btn:disabled {
  background: #4a4a5a;
  color: #6b7280;
}
@media (prefers-contrast: high) {
  .delete-bundle-dialog {
    border: 2px solid #000000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .delete-bundle-dialog * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.delete-bundle-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #ffffff !important;
  color: #1a1a1a;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 12px 12px 0 0 !important;
  overflow: hidden !important;
  position: relative;
  z-index: 2;
}
.delete-bundle-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.delete-bundle-dialog .dialog-header .header-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.delete-bundle-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
  --mat-mdc-button-persistent-ripple-color: transparent;
  --mat-mdc-button-ripple-color: transparent;
  --mdc-icon-button-state-layer-size: 0;
  --mdc-icon-button-state-layer-color: transparent;
  --mdc-ripple-color: transparent;
  --mat-mdc-button-persistent-ripple-opacity: 0;
  --mat-mdc-button-ripple-opacity: 0;
}
.delete-bundle-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.delete-bundle-dialog .dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.delete-bundle-dialog .dialog-header .close-button:focus {
  outline: none;
}
.delete-bundle-dialog .dialog-header .close-button:focus-visible {
  outline: none;
}
.delete-bundle-dialog .dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-bundle-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  -webkit-overflow-scrolling: touch;
}
.delete-bundle-dialog .dialog-content .warning-content {
  text-align: center;
}
.delete-bundle-dialog .dialog-content .warning-content .warning-icon-large {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #dc3545;
  opacity: 0.8;
}
.delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-progress-spinner {
  margin: 0 auto;
}
.delete-bundle-dialog .dialog-content .warning-content h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.delete-bundle-dialog .dialog-content .warning-content p {
  margin: 0 0 20px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #666;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.delete-bundle-dialog .dialog-content .warning-content .info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
}
.delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
  color: #6c757d;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}
.delete-bundle-dialog .dialog-content .warning-content .info-box span {
  font-size: 13px;
  line-height: 1.4;
  color: #495057;
}
.delete-bundle-dialog .dialog-actions {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: sticky;
  bottom: 0;
  min-height: 60px;
  border-radius: 0 0 12px 12px !important;
  overflow: hidden !important;
}
.delete-bundle-dialog .dialog-actions .cancel-btn,
.delete-bundle-dialog .dialog-actions .delete-btn {
  flex: 1;
  height: 40px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}
.delete-bundle-dialog .dialog-actions .cancel-btn mat-icon,
.delete-bundle-dialog .dialog-actions .delete-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.delete-bundle-dialog .dialog-actions .cancel-btn {
  background: white;
  color: #666;
  border: 1px solid #e0e0e0;
}
.delete-bundle-dialog .dialog-actions .cancel-btn:hover {
  background: #f5f5f5;
  border-color: #ccc;
}
.delete-bundle-dialog .dialog-actions .delete-btn {
  background: #dc3545;
  color: white;
  border: none;
}
.delete-bundle-dialog .dialog-actions .delete-btn:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}
.delete-bundle-dialog .dialog-actions .delete-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .delete-bundle-dialog {
    max-height: 95vh;
    max-width: calc(100vw - 32px);
    width: calc(100vw - 32px);
    margin: 16px;
    border-radius: 8px;
    min-height: 180px;
  }
  .delete-bundle-dialog .dialog-header {
    padding: 16px 20px;
  }
  .delete-bundle-dialog .dialog-header h2 {
    font-size: 18px;
  }
  .delete-bundle-dialog .dialog-content {
    padding: 20px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 56px;
    width: 56px;
    height: 56px;
  }
  .delete-bundle-dialog .dialog-content .warning-content h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }
  .delete-bundle-dialog .dialog-content .warning-content p {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box {
    padding: 14px;
    gap: 10px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box span {
    font-size: 12px;
  }
  .delete-bundle-dialog .dialog-actions {
    padding: 16px 20px;
    min-height: 56px;
    flex-shrink: 0;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn,
  .delete-bundle-dialog .dialog-actions .delete-btn {
    height: 48px;
    font-size: 14px;
    min-height: 48px;
    touch-action: manipulation;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn mat-icon,
  .delete-bundle-dialog .dialog-actions .delete-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
@media (max-width: 480px) {
  .delete-bundle-dialog {
    margin: 8px;
    max-width: calc(100vw - 80px);
    width: calc(100vw - 16px);
    border-radius: 6px;
    min-height: 160px;
  }
  .delete-bundle-dialog .dialog-header {
    padding: 12px 16px;
  }
  .delete-bundle-dialog .dialog-header h2 {
    font-size: 16px;
  }
  .delete-bundle-dialog .dialog-content {
    padding: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 12px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  .delete-bundle-dialog .dialog-content .warning-content h3 {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .delete-bundle-dialog .dialog-content .warning-content p {
    font-size: 12px;
    margin-bottom: 14px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box {
    padding: 12px;
    gap: 8px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box span {
    font-size: 11px;
  }
  .delete-bundle-dialog .dialog-actions {
    padding: 12px 16px;
    min-height: 52px;
    flex-shrink: 0;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn,
  .delete-bundle-dialog .dialog-actions .delete-btn {
    height: 44px;
    font-size: 13px;
    gap: 6px;
    min-height: 44px;
    touch-action: manipulation;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn mat-icon,
  .delete-bundle-dialog .dialog-actions .delete-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 768px) and (orientation: landscape) {
  .delete-bundle-dialog {
    max-height: 100vh;
    max-width: calc(100vw - 80px);
    width: calc(100vw - 24px);
    margin: 12px;
  }
  .delete-bundle-dialog .dialog-header {
    padding: 12px 16px;
  }
  .delete-bundle-dialog .dialog-header h2 {
    font-size: 16px;
  }
  .delete-bundle-dialog .dialog-content {
    padding: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 12px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
  }
  .delete-bundle-dialog .dialog-content .warning-content h3 {
    font-size: 15px;
    margin-bottom: 8px;
  }
  .delete-bundle-dialog .dialog-content .warning-content p {
    font-size: 12px;
    margin-bottom: 12px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box {
    padding: 12px;
    gap: 8px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box span {
    font-size: 11px;
  }
  .delete-bundle-dialog .dialog-actions {
    padding: 12px 16px;
    min-height: 48px;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn,
  .delete-bundle-dialog .dialog-actions .delete-btn {
    height: 40px;
    font-size: 13px;
    min-height: 40px;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn mat-icon,
  .delete-bundle-dialog .dialog-actions .delete-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 360px) {
  .delete-bundle-dialog {
    margin: 4px;
    max-width: calc(100vw - 60px);
    width: calc(100vw - 8px);
    border-radius: 4px;
    min-height: 140px;
  }
  .delete-bundle-dialog .dialog-header {
    padding: 10px 0px;
  }
  .delete-bundle-dialog .dialog-header h2 {
    font-size: 14px;
  }
  .delete-bundle-dialog .dialog-content {
    padding: 12px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large {
    margin-bottom: 10px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .warning-icon-large mat-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  .delete-bundle-dialog .dialog-content .warning-content h3 {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .delete-bundle-dialog .dialog-content .warning-content p {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box {
    padding: 10px;
    gap: 6px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box .info-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .delete-bundle-dialog .dialog-content .warning-content .info-box span {
    font-size: 10px;
  }
  .delete-bundle-dialog .dialog-actions {
    padding: 10px 12px;
    min-height: 48px;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn,
  .delete-bundle-dialog .dialog-actions .delete-btn {
    height: 40px;
    font-size: 12px;
    min-height: 40px;
    gap: 4px;
  }
  .delete-bundle-dialog .dialog-actions .cancel-btn mat-icon,
  .delete-bundle-dialog .dialog-actions .delete-btn mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/delete-bundle-dialog/delete-bundle-dialog.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;AAAF;AAGE;EACE,8BAAA;EACA,cAAA;EACA,yCAAA;AADJ;AAGI;EACE,8BAAA;EACA,cAAA;EACA,4BAAA;AADN;AAGM;EACE,cAAA;AADR;AAIM;EACE,cAAA;AAFR;AAIQ;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAFV;AAKQ;EACE,mBAAA;AAHV;AAUQ;EACE,cAAA;AARV;AAWQ;EACE,cAAA;AATV;AAYQ;EACE,mBAAA;EACA,qBAAA;AAVV;AAYU;EACE,cAAA;AAVZ;AAaU;EACE,cAAA;AAXZ;AAiBI;EACE,8BAAA;EACA,yBAAA;AAfN;AAiBM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfR;AAiBQ;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAfV;AAoBQ;EACE,mBAAA;EACA,cAAA;AAlBV;AAyBE;EAjGF;IAkGI,yBAAA;EAtBF;AACF;AAyBE;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAvBJ;AACF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAxBJ;AA0BI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAxBN;AA2BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzBN;AA4BI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,qDAAA;EACA,0CAAA;EACA,qCAAA;EACA,gDAAA;EACA,+BAAA;EACA,6CAAA;EACA,kCAAA;AA1BN;AA4BM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA1BR;AA6BM;EACE,mBAAA;EACA,sBAAA;AA3BR;AA8BM;EACE,aAAA;AA5BR;AA+BM;EACE,aAAA;AA7BR;AAgCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9BR;AAmCE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;AAjCJ;AAmCI;EACE,kBAAA;AAjCN;AAmCM;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCR;AAmCQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAjCV;AAoCQ;EACE,cAAA;AAlCV;AAsCM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApCR;AAuCM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AArCR;AAwCM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAtCR;AAwCQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAtCV;AAyCQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvCV;AA6CE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,uCAAA;EACA,2BAAA;AA3CJ;AA6CI;;EAEE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AA3CN;AA6CM;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1CR;AA8CI;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;AA5CN;AA8CM;EACE,mBAAA;EACA,kBAAA;AA5CR;AAgDI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AA9CN;AAgDM;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AA9CR;AAiDM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/CR;;AAsDA;EACE;IACE,gBAAA;IACA,6BAAA;IACA,yBAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;EAnDF;EAqDE;IACE,kBAAA;EAnDJ;EAqDI;IACE,eAAA;EAnDN;EAuDE;IACE,aAAA;EArDJ;EAwDM;IACE,mBAAA;EAtDR;EAwDQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAtDV;EA0DM;IACE,eAAA;IACA,mBAAA;EAxDR;EA2DM;IACE,eAAA;IACA,mBAAA;EAzDR;EA4DM;IACE,aAAA;IACA,SAAA;EA1DR;EA4DQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA1DV;EA6DQ;IACE,eAAA;EA3DV;EAiEE;IACE,kBAAA;IACA,gBAAA;IACA,cAAA;EA/DJ;EAiEI;;IAEE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,0BAAA;EA/DN;EAiEM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA9DR;AACF;AAoEA;EACE;IACE,WAAA;IACA,6BAAA;IACA,yBAAA;IACA,kBAAA;IACA,iBAAA;EAlEF;EAoEE;IACE,kBAAA;EAlEJ;EAoEI;IACE,eAAA;EAlEN;EAsEE;IACE,aAAA;EApEJ;EAuEM;IACE,mBAAA;EArER;EAuEQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArEV;EAyEM;IACE,eAAA;IACA,mBAAA;EAvER;EA0EM;IACE,eAAA;IACA,mBAAA;EAxER;EA2EM;IACE,aAAA;IACA,QAAA;EAzER;EA2EQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzEV;EA4EQ;IACE,eAAA;EA1EV;EAgFE;IACE,kBAAA;IACA,gBAAA;IACA,cAAA;EA9EJ;EAgFI;;IAEE,YAAA;IACA,eAAA;IACA,QAAA;IACA,gBAAA;IACA,0BAAA;EA9EN;EAgFM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA7ER;AACF;AAoFA;EACE;IACE,iBAAA;IACA,6BAAA;IACA,yBAAA;IACA,YAAA;EAlFF;EAoFE;IACE,kBAAA;EAlFJ;EAoFI;IACE,eAAA;EAlFN;EAsFE;IACE,aAAA;EApFJ;EAuFM;IACE,mBAAA;EArFR;EAuFQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArFV;EAyFM;IACE,eAAA;IACA,kBAAA;EAvFR;EA0FM;IACE,eAAA;IACA,mBAAA;EAxFR;EA2FM;IACE,aAAA;IACA,QAAA;EAzFR;EA2FQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzFV;EA4FQ;IACE,eAAA;EA1FV;EAgGE;IACE,kBAAA;IACA,gBAAA;EA9FJ;EAgGI;;IAEE,YAAA;IACA,eAAA;IACA,gBAAA;EA9FN;EAgGM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA7FR;AACF;AAoGA;EACE;IACE,WAAA;IACA,6BAAA;IACA,wBAAA;IACA,kBAAA;IACA,iBAAA;EAlGF;EAoGE;IACE,iBAAA;EAlGJ;EAoGI;IACE,eAAA;EAlGN;EAsGE;IACE,aAAA;EApGJ;EAuGM;IACE,mBAAA;EArGR;EAuGQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArGV;EAyGM;IACE,eAAA;IACA,kBAAA;EAvGR;EA0GM;IACE,eAAA;IACA,mBAAA;EAxGR;EA2GM;IACE,aAAA;IACA,QAAA;EAzGR;EA2GQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzGV;EA4GQ;IACE,eAAA;EA1GV;EAgHE;IACE,kBAAA;IACA,gBAAA;EA9GJ;EAgHI;;IAEE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,QAAA;EA9GN;EAgHM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA7GR;AACF","sourcesContent":["// Styled to match the Delete Flow modal\n.delete-bundle-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  width: 100%;\n  max-width: 500px;\n  min-height: 200px;\n  background: #ffffff !important;\n  border-radius: 12px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden !important;\n  position: relative;\n  z-index: 1;\n  margin: 0 !important;\n  padding: 0 !important;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background: #1e1e2e !important;\n    color: #e2e8f0;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n\n    .dialog-header {\n      background: #1e1e2e !important;\n      color: #e2e8f0;\n      border-bottom-color: #2d2d3f;\n\n      h2 {\n        color: #e2e8f0;\n      }\n\n      .close-button {\n        color: #94a3b8;\n\n        &:hover {\n          background: #2d2d3f;\n          color: #cbd5e1;\n          border-color: #3d3d52;\n        }\n\n        &:active {\n          background: #3d3d52;\n        }\n      }\n    }\n\n    .dialog-content {\n      .warning-content {\n        h3 {\n          color: #e2e8f0;\n        }\n\n        p {\n          color: #94a3b8;\n        }\n\n        .info-box {\n          background: #2d2d3f;\n          border-color: #3d3d52;\n\n          .info-icon {\n            color: #64748b;\n          }\n\n          span {\n            color: #94a3b8;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      background: #181825 !important;\n      border-top-color: #2d2d3f;\n\n      .cancel-btn {\n        background: #2d2d3f;\n        color: #94a3b8;\n        border-color: #3d3d52;\n\n        &:hover {\n          background: #3d3d52;\n          border-color: #4d4d62;\n          color: #cbd5e1;\n        }\n      }\n\n      .delete-btn {\n        &:disabled {\n          background: #4a4a5a;\n          color: #6b7280;\n        }\n      }\n    }\n  }\n\n  // High contrast support\n  @media (prefers-contrast: high) {\n    border: 2px solid #000000;\n  }\n\n  // Reduced motion support\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    background: #ffffff !important;\n    color: #1a1a1a;\n    border-bottom: 1px solid #e0e0e0;\n    border-radius: 12px 12px 0 0 !important;\n    overflow: hidden !important;\n    position: relative;\n    z-index: 2;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .header-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: transparent;\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n      --mat-mdc-button-persistent-ripple-color: transparent;\n      --mat-mdc-button-ripple-color: transparent;\n      --mdc-icon-button-state-layer-size: 0;\n      --mdc-icon-button-state-layer-color: transparent;\n      --mdc-ripple-color: transparent;\n      --mat-mdc-button-persistent-ripple-opacity: 0;\n      --mat-mdc-button-ripple-opacity: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n        border-color: #e5e7eb;\n      }\n\n      &:active {\n        background: #e5e7eb;\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 24px;\n    -webkit-overflow-scrolling: touch;\n\n    .warning-content {\n      text-align: center;\n\n      .warning-icon-large {\n        margin-bottom: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        mat-icon {\n          font-size: 64px;\n          width: 64px;\n          height: 64px;\n          color: #dc3545;\n          opacity: 0.8;\n        }\n\n        mat-progress-spinner {\n          margin: 0 auto;\n        }\n      }\n\n      h3 {\n        margin: 0 0 16px 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: #333;\n      }\n\n      p {\n        margin: 0 0 20px 0;\n        font-size: 14px;\n        line-height: 1.5;\n        color: #666;\n        max-width: 400px;\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .info-box {\n        display: flex;\n        align-items: flex-start;\n        gap: 12px;\n        background: #f8f9fa;\n        border: 1px solid #e9ecef;\n        border-radius: 8px;\n        padding: 16px;\n        text-align: left;\n\n        .info-icon {\n          color: #6c757d;\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n          flex-shrink: 0;\n          margin-top: 2px;\n        }\n\n        span {\n          font-size: 13px;\n          line-height: 1.4;\n          color: #495057;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    gap: 12px;\n    padding: 20px 24px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    position: sticky;\n    bottom: 0;\n    min-height: 60px;\n    border-radius: 0 0 12px 12px !important;\n    overflow: hidden !important;\n\n    .cancel-btn,\n    .delete-btn {\n      flex: 1;\n      height: 40px;\n      border-radius: 8px;\n      font-weight: 500;\n      font-size: 14px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      margin-top: 20px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .cancel-btn {\n      background: white;\n      color: #666;\n      border: 1px solid #e0e0e0;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n    }\n\n    .delete-btn {\n      background: #dc3545;\n      color: white;\n      border: none;\n\n      &:hover:not(:disabled) {\n        background: #c82333;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n      }\n\n      &:disabled {\n        background: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .delete-bundle-dialog {\n    max-height: 95vh;\n    max-width: calc(100vw - 32px);\n    width: calc(100vw - 32px);\n    margin: 16px;\n    border-radius: 8px;\n    min-height: 180px;\n\n    .dialog-header {\n      padding: 16px 20px;\n\n      h2 {\n        font-size: 18px;\n      }\n    }\n\n    .dialog-content {\n      padding: 20px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 16px;\n\n          mat-icon {\n            font-size: 56px;\n            width: 56px;\n            height: 56px;\n          }\n        }\n\n        h3 {\n          font-size: 16px;\n          margin-bottom: 12px;\n        }\n\n        p {\n          font-size: 13px;\n          margin-bottom: 16px;\n        }\n\n        .info-box {\n          padding: 14px;\n          gap: 10px;\n\n          .info-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 16px 20px;\n      min-height: 56px;\n      flex-shrink: 0;\n\n      .cancel-btn,\n      .delete-btn {\n        height: 48px;\n        font-size: 14px;\n        min-height: 48px;\n        touch-action: manipulation;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .delete-bundle-dialog {\n    margin: 8px;\n    max-width: calc(100vw - 80px);\n    width: calc(100vw - 16px);\n    border-radius: 6px;\n    min-height: 160px;\n\n    .dialog-header {\n      padding: 12px 16px;\n\n      h2 {\n        font-size: 16px;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 12px;\n\n          mat-icon {\n            font-size: 48px;\n            width: 48px;\n            height: 48px;\n          }\n        }\n\n        h3 {\n          font-size: 15px;\n          margin-bottom: 10px;\n        }\n\n        p {\n          font-size: 12px;\n          margin-bottom: 14px;\n        }\n\n        .info-box {\n          padding: 12px;\n          gap: 8px;\n\n          .info-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n\n          span {\n            font-size: 11px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 16px;\n      min-height: 52px;\n      flex-shrink: 0;\n\n      .cancel-btn,\n      .delete-btn {\n        height: 44px;\n        font-size: 13px;\n        gap: 6px;\n        min-height: 44px;\n        touch-action: manipulation;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n// Landscape orientation support for mobile devices\n@media (max-width: 768px) and (orientation: landscape) {\n  .delete-bundle-dialog {\n    max-height: 100vh;\n    max-width: calc(100vw - 80px);\n    width: calc(100vw - 24px);\n    margin: 12px;\n\n    .dialog-header {\n      padding: 12px 16px;\n\n      h2 {\n        font-size: 16px;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 12px;\n\n          mat-icon {\n            font-size: 48px;\n            width: 48px;\n            height: 48px;\n          }\n        }\n\n        h3 {\n          font-size: 15px;\n          margin-bottom: 8px;\n        }\n\n        p {\n          font-size: 12px;\n          margin-bottom: 12px;\n        }\n\n        .info-box {\n          padding: 12px;\n          gap: 8px;\n\n          .info-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n\n          span {\n            font-size: 11px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 16px;\n      min-height: 48px;\n\n      .cancel-btn,\n      .delete-btn {\n        height: 40px;\n        font-size: 13px;\n        min-height: 40px;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n// Extra small devices (phones in portrait)\n@media (max-width: 360px) {\n  .delete-bundle-dialog {\n    margin: 4px;\n    max-width: calc(100vw - 60px);\n    width: calc(100vw - 8px);\n    border-radius: 4px;\n    min-height: 140px;\n\n    .dialog-header {\n      padding: 10px 0px;\n\n      h2 {\n        font-size: 14px;\n      }\n    }\n\n    .dialog-content {\n      padding: 12px;\n\n      .warning-content {\n        .warning-icon-large {\n          margin-bottom: 10px;\n\n          mat-icon {\n            font-size: 40px;\n            width: 40px;\n            height: 40px;\n          }\n        }\n\n        h3 {\n          font-size: 14px;\n          margin-bottom: 8px;\n        }\n\n        p {\n          font-size: 11px;\n          margin-bottom: 10px;\n        }\n\n        .info-box {\n          padding: 10px;\n          gap: 6px;\n\n          .info-icon {\n            font-size: 14px;\n            width: 14px;\n            height: 14px;\n          }\n\n          span {\n            font-size: 10px;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 10px 12px;\n      min-height: 48px;\n\n      .cancel-btn,\n      .delete-btn {\n        height: 40px;\n        font-size: 12px;\n        min-height: 40px;\n        gap: 4px;\n\n        mat-icon {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
